import { create } from 'zustand'

export const useModalStore = create((set) => ({
    title: null,
    children: null,
    open: false,
    setModal: (title, children, open) => set((state) => ({ ...state, title, children, open })),
    setOpen: (open) => set((state) => ({ ...state, open }))
}))